export const categories = [
  { slug: 'rexue', name: '热血', nameEn: 'Action', description: '充满激情与战斗的热血漫画', comicCount: 1280 },
  { slug: 'aiqing', name: '爱情', nameEn: 'Romance', description: '甜蜜浪漫的爱情故事', comicCount: 1560 },
  { slug: 'xuanyi', name: '悬疑', nameEn: 'Thriller', description: '扣人心弦的悬疑推理', comicCount: 890 },
  { slug: 'qihuan', name: '奇幻', nameEn: 'Fantasy', description: '充满想象力的奇幻世界', comicCount: 2100 },
  { slug: 'xiaoyuan', name: '校园', nameEn: 'School Life', description: '青春洋溢的校园生活', comicCount: 760 },
  { slug: 'danmei', name: '耽美', nameEn: 'BL', description: '唯美动人的耽美作品', comicCount: 1340 },
  { slug: 'kongbu', name: '恐怖', nameEn: 'Horror', description: '惊悚刺激的恐怖漫画', comicCount: 450 },
  { slug: 'gaoxiao', name: '搞笑', nameEn: 'Comedy', description: '轻松愉快的搞笑漫画', comicCount: 920 },
  { slug: 'kehuan', name: '科幻', nameEn: 'Sci-Fi', description: '未来世界的科幻畅想', comicCount: 680 },
];

export const allCategories = categories;